import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CLIENTS_QUERY_KEYS } from "Clients/Api/Queries/queryKeys";
import { postClients, type SaveClientRequest } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export function useCreateClientMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveClientRequest) =>
      postClients(request),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: CLIENTS_QUERY_KEYS.all,
      });
    },
  });
}
